import { IndexedFilters } from '../types/filters';
import { FilterLabelLookup } from './parse-indexed-filter-for-label';
import { isIndexedNestedFilter } from './remove-selected-filter';

/**
 * Check if filter lookup is in selected filters.
 *
 * @param filter filter to lookup
 * @param selectedFilters current selected filters
 * @returns True if filter lookup is in selected filters, false otherwise
 */
export default function hasSelectedFilter(
  filter: FilterLabelLookup,
  selectedFilters: IndexedFilters
) {
  const currentValue = selectedFilters[filter.key];

  if (Array.isArray(currentValue)) {
    // If the filter value is an array, check if all values are included in the current selected filters.
    // Otherwise, check if the value is included in the current selected filters.
    return (
      (!Array.isArray(filter.value) &&
        typeof filter.value !== 'object' &&
        currentValue.includes(filter.value)) ||
      (Array.isArray(filter.value) &&
        filter.value.every((value) => currentValue.includes(value)))
    );
  }

  if (isIndexedNestedFilter(currentValue) && filter.subKey) {
    // Note: we make an assumption that nested filters will never have buckets of values
    const currentSubValue = currentValue[filter.subKey as string];
    return currentSubValue.includes(filter.value as string);
  }

  return false;
}
